import classNames from 'classnames';
import Footer from 'components/footers/Footer';
import NavbarDual from 'components/navbars/navbar-dual/NavbarDual';
import NavbarTopHorizontal from 'components/navbars/navbar-horizontal/NavbarTopHorizontal';
import NavbarTopDefault from 'components/navbars/navbar-top/NavbarTopDefault';
import NavbarVertical from 'components/navbars/navbar-vertical/NavbarVertical';
import { useAppContext } from 'providers/AppProvider';
import { useMainLayoutContext } from 'providers/MainLayoutProvider';
import { useAccessToken } from 'providers/AccessTokenProvider';
import { TaskDetailsProvider } from 'providers/TaskDetailsProvider';
import { Container } from 'react-bootstrap';
import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const MainLayout = () => {
  const {
    config: { navbarPosition }
  } = useAppContext();

  const { contentClass, footerClass } = useMainLayoutContext();
  const { refreshUserData } = useAccessToken();
  const location = useLocation();

  useEffect(() => {
    refreshUserData();
  }, [location.pathname]);

  return (
    <TaskDetailsProvider>
      <Container fluid className="px-0">
        {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
          <NavbarVertical />
        )}
        {navbarPosition === 'vertical' && <NavbarTopDefault />}
        {(navbarPosition === 'horizontal' || navbarPosition === 'combo') && (
          <NavbarTopHorizontal />
        )}
        {navbarPosition === 'dual' && <NavbarDual />}

        <div className={classNames(contentClass, 'content')}>
          <Outlet />
          <Footer className={classNames(footerClass, 'position-absolute')} />
        </div>
      </Container>
    </TaskDetailsProvider>
  );
};

export default MainLayout;
